import React, { useContext, useState, useEffect } from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";
import { FaPlus, FaRegMessage, FaTrash } from "react-icons/fa6";
import { FaThumbtack, FaPen } from "react-icons/fa";
import "./Sidebar.css";
import { dataContext } from "../../context/UserContext";

function Sidebar() {
    const [isOpen, setIsOpen] = useState(false);
    const [showHelp, setShowHelp] = useState(false);
    const { newChat, conversations, selectConversation, activeConversationId, renameConversation, deleteConversation, togglePinConversation } = useContext(dataContext);
    const [editingId, setEditingId] = useState(null);
    const [tempTitle, setTempTitle] = useState("");

    const iconBtnStyle = {
        background:'none',
        border:'none',
        cursor:'pointer',
        color:'var(--color)',
        padding:'4px',
        display:'flex',
        alignItems:'center'
    };

    function toggleSidebar() {
        setIsOpen(prev => !prev);
    }

    function closeSidebar() {
        setIsOpen(false);
    }

    // Apply body class when sidebar state changes (mobile only breakpoint logic can be handled in CSS)
    useEffect(()=>{
        if(isOpen){
            document.body.classList.add('sidebar-open');
        } else {
            document.body.classList.remove('sidebar-open');
        }
    },[isOpen]);

    function handleSelectConversation(id){
        selectConversation(id);
        setIsOpen(false);
    }

    function handleNewChat() {
        newChat();
    setIsOpen(false); // Hide sidebar after new chat
    }

    function toggleHelp(){
        setShowHelp(prev=>!prev);
    }

    return (
        <>
            {/* Hamburger Icon (Only visible on mobile) */}
            <GiHamburgerMenu id="ham" onClick={toggleSidebar} />

            {/* Mobile Overlay */}
            {isOpen && <div className="sidebar-overlay" onClick={closeSidebar}></div>}

            {/* Sidebar */}
            <div className={`sidebar ${isOpen ? "active" : ""}`}>
                {/* Close Button inside Sidebar */}
              {/* <GiHamburgerMenu id="ham" onClick={toggleSidebar} /> */}

                <div className="newchat" onClick={handleNewChat}>
                    <FaPlus />
                    <p>New Chat</p>
                </div>
                <div className="history-wrapper">
                    {conversations.map(conv => (
                        <div 
                          key={conv.id} 
                          className="recent" 
                          style={conv.id === activeConversationId ? {backgroundColor:'rgba(128,133,134,0.5)'} : {}}
                        >
                            <div style={{display:'flex',alignItems:'center',gap:'6px',flex:1,cursor:'pointer'}} onClick={() => handleSelectConversation(conv.id)}>
                                <FaRegMessage />
                                {editingId === conv.id ? (
                                    <input 
                                      value={tempTitle} 
                                      onChange={e=>setTempTitle(e.target.value)} 
                                      onBlur={()=>{renameConversation(conv.id, tempTitle.trim() || 'Untitled'); setEditingId(null);}} 
                                      onKeyDown={e=>{if(e.key==='Enter'){renameConversation(conv.id, tempTitle.trim() || 'Untitled'); setEditingId(null);}}}
                                      autoFocus
                                      style={{flex:1,fontSize:'13px',background:'transparent',border:'1px solid rgba(128,133,134,0.4)',color:'var(--color)',borderRadius:'6px',padding:'2px 6px'}}
                                    />
                                                                ) : (
                                                                        <p 
                                                                            style={{margin:0,flex:1}} 
                                                                            title={conv.title || 'Untitled'}
                                                                        >
                                                                            {/* Truncate to 6 chars plus ellipsis if longer */}
                                                                            {(conv.title || 'Untitled').length > 6 
                                                                                ? (conv.title || 'Untitled').slice(0,6) + '...' 
                                                                                : (conv.title || 'Untitled')}
                                                                        </p>
                                                                )}
                            </div>
                            <div style={{display:'flex',alignItems:'center',gap:'4px'}}>
                                <button onClick={()=>togglePinConversation(conv.id)} title={conv.pinned ? 'Unpin' : 'Pin'} style={iconBtnStyle}>
                                    <FaThumbtack style={{transform: conv.pinned? 'none':'rotate(25deg)'}} />
                                </button>
                                <button onClick={()=>{setEditingId(conv.id); setTempTitle(conv.title);}} title='Rename' style={iconBtnStyle}><FaPen /></button>
                                <button onClick={()=>{ if(window.confirm('Delete this conversation?')) deleteConversation(conv.id); }} title='Delete' style={iconBtnStyle}><FaTrash /></button>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="gethelp" onClick={toggleHelp}>
                    <span>Get Help</span>
                </div>
            </div>
            {showHelp && (
                <div className="help-modal-overlay" onClick={toggleHelp}>
                    <div className="help-modal" onClick={(e)=>e.stopPropagation()}>
                        <h3>Support</h3>
                        <p><strong>Name:</strong> Shashank Shekhar</p>
                        <p><strong>LinkedIn:</strong> <a href="https://www.linkedin.com/in/thisisshashankshekhar/" target="_blank" rel="noopener noreferrer">/in/thisisshashankshekhar <FaExternalLinkAlt style={{width:'11px',height:'11px'}} /></a></p>
                        <p><strong>Email:</strong> <a href="mailto:mbox.shashank@gmail.com">mbox.shashank@gmail.com</a></p>
                        <button className="close-help" onClick={toggleHelp}>Close</button>
                        
                    </div>
                </div>
            )}
        </>
    );
}

export default Sidebar;
